import { Modal } from "react-bootstrap";
import IcX from "../Svg/IcX";
import styles from "./style.module.css";
import { useEffect, useState } from "react";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import Slct from "../Slct";
import DatePicker from "../DatePicker";
import useFormat from "../../hooks/utils/useFormat";
import { useOutletContext } from "react-router-dom";
import Button from "../Button";
import { toast } from "react-toastify";

export default function ModaProductContribution(props) {
  const { show, closeModal, productPreLoad } = props;
  const { me, config } = useWrapper();
  const { formatReal } = useFormat();
  const { commercial, reload, setreload } = useOutletContext();

  const [contribution, setcontribution] = useState();
  useEffect(() => {
    (async function () {
      if (productPreLoad) {
        const { data: _custom_payment } = await api.get(`get-custom-payment-values/${productPreLoad.id}`, config);
        setcontribution(_custom_payment);
      }
    })();
    // config is recreated every render; effect is intentionally keyed to productPreLoad only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productPreLoad]);

  const [options, setoptions] = useState();

  const [loading, setloading] = useState();
  const updateDateEnd = async () => {
    setloading(true);
    try {
      await api.put(
        `custom-payment/${productPreLoad?.id}`,
        {
          date_end: options?.date_end,
        },
        config,
      );
      setreload(!reload);
      toast.success("Disponibilidade estendida com sucesso!");
    } catch (__err) {
      console.log("__err", __err);
      toast.error("Problema ao tentar atualizar Produto!");
    }
    closeModal();
    setloading(false);
  };

  const endProductSell = async () => {
    setloading(true);
    try {
      if (contribution?.pago?.aporte > 0) {
        await api.post(
          "contribution-single",
          {
            commercial_id: commercial?.id,
            contribution: productPreLoad.name,
            description: `Aporte gerado a partir do produto ${productPreLoad.name}`,
            due_date: new Date(),
            protocol_attendance: "",
            user_id: me?.id,
            value: contribution?.pago?.aporte || 0,
            trainees: options?.trainee_multi?.map(__trainee => __trainee.value),
          },
          config,
        );
        toast.success("Aporte distribuido com sucesso!");
      }
      await api.put(
        `custom-payment/${productPreLoad?.id}`,
        {
          contribution_done: 1,
        },
        config,
      );
      setreload(!reload);
      toast.success("Venda finalizada com sucesso!");
    } catch (__err) {
      console.log("__err", __err);
      toast.error("Problema ao tentar atualizar Produto!");
    }
    closeModal();
    setloading(false);
  };

  useEffect(() => {
    setoptions();
  }, [show]);

  return (
    <>
      <Modal size="md" show={show} onHide={closeModal} centered>
        <Modal.Header>
          <div as="label" className="d-flex w-100">
            <h2 className="page-title">{productPreLoad?.name}</h2>
          </div>
          <button className={styles.closeModal} onClick={closeModal}>
            <IcX />
          </button>
        </Modal.Header>
        {!productPreLoad?.contribution_done ? (
          <>
            <Modal.Body>
              <p>
                O período de dispobilidade desse produto se encerrou. Você deve estender a disponibilidade ou encerrar
                finalizar as vendas do produto.
              </p>
              <Slct
                placeholder="..."
                options={[
                  { value: "extend", label: "Estender Dispobilidade" },
                  {
                    value: "end",
                    label: `Finalizar Venda${contribution?.pago?.aporte > 0 ? " e Distribuir Aporte" : ""}`,
                  },
                ]}
                value={options?.action}
                onChange={__ev => {
                  setoptions({
                    ...options,
                    action: __ev.value,
                    trainee_multi: [],
                    date_end: null,
                  });
                }}
              />
              {options?.action === "extend" && (
                <div className="mt-2">
                  <label>Data Encerramento</label>
                  <DatePicker
                    selected={options?.date_end}
                    changeDate={__e => {
                      setoptions({
                        ...options,
                        date_end: __e,
                      });
                    }}
                    minDate={new Date()}
                  />
                </div>
              )}
              {options?.action === "end" && (
                <div>
                  {contribution?.pago?.aporte > 0 && (
                    <>
                      <div className="divisor mt-3 mb-3"></div>
                      <p>
                        Existem <b>{formatReal(contribution?.pago?.aporte || 0)}</b> para serem aportados. Selecione os
                        formandos que vão dividir esse benefício.
                      </p>
                      <Slct
                        isMulti="true"
                        options={
                          commercial?.trainees?.map(__trainee => ({
                            value: __trainee.id,
                            label: __trainee.name,
                          })) || []
                        }
                        placeholder="..."
                        value={options?.trainee_multi || []}
                        name="selects.trainee_multi"
                        onChange={__ev => {
                          setoptions({
                            ...options,
                            trainee_multi: __ev,
                          });
                        }}
                      />
                    </>
                  )}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {options?.action === "extend" && (
                <>
                  <Button onClick={updateDateEnd} loading={loading} disabled={!options?.date_end}>
                    Estender Disponibilidade
                  </Button>
                </>
              )}
              {options?.action === "end" && (
                <>
                  <Button
                    onClick={endProductSell}
                    loading={loading}
                    disabled={!(options?.trainee_multi?.length > 0) && contribution?.pago?.aporte}
                  >
                    Finalizar Venda{contribution?.pago?.aporte > 0 && " e Distribuir Aporte"}
                  </Button>
                </>
              )}
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Body>
              <p className="m-0 small-label">{productPreLoad?.description || "-"}</p>
              <div className="divisor mt-3 mb-3"></div>
              <p className="m-0">
                <b>Centro de Custo:</b> {productPreLoad?.costCenters?.name}
              </p>
              <p className="m-0">
                <b>Plano de Conta:</b> {productPreLoad?.expensePlans?.name}
              </p>
              <p className="m-0">
                <b>Conta:</b> {productPreLoad?.expenses?.name}
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={closeModal}>Fechar</Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
}
